import { action } from 'typesafe-actions'
import { GuideTypes } from './types'

export const changeHomeGuide = (payload: boolean) => action(GuideTypes.CHANGE_HOMEGUIDE, payload)
